require('./registration.style.scss');

let GOOGLE_API = 'https://accounts.google.com/o/oauth2/auth';
let LOGIN_INITIATED = 'login-initiated';

class RegistrationController {
    constructor($element, $rootScope, $scope, $stateParams, $filter, $timeout, $location, $localStorage, registrationService, validationsService, config, contentSwitcherService, sseService) {
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$localStorage = $localStorage;
        this.registrationService = registrationService;
        this.validationsService = validationsService;
        this.config = config;
        this.loginObj = $stateParams.loginObj;
        this.contentSwitcherService = contentSwitcherService;
        this.sseService = sseService;
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === "function";
        this.LOGIN_STATE = 'login';
        this.REGISTRATION_STATE = 'registration';
        this.PROGRESS_STATE = 'progress';
        this.resolveStatus = 'RUNNING';
        this.activateStatus = 'READY';
        this.deployStatus = 'READY';
        this.isDeployed = false;
        this.companyNamePattern = this.validationsService.getCompanyNamePattern();

        this.marketplaceToken = $location.search().marketplaceToken;
        this.countries = [];
        this.registration = {
            marketplaceToken: this.marketplaceToken
        };
        this.procurementAccountId = null;

        this.help = this.$filter('translate')('registration.page.form.help');
        this.showBillingWarning = false;

        const protocol = window.location.protocol ? window.location.protocol : 'http:';

        this.msalConfig = {
            identityMetadata: "https://login.microsoftonline.com/common/oauth2/v2.0/",
            clientId: config.clientId,
            responseType: "code",
            responseMode: "query",
            redirectUrl: protocol + '//' + window.location.host + '/#!/signup',
            scope: ["https://management.azure.com/user_impersonation"]
        };

        this.$rootScope.$on("deployment.finished", (event, data) => {
            if (data === 'SUCCEEDED') {
                this.isDeployed = true;
                this.deployStatus = 'DONE';
                this.$timeout(() => {
                    $scope.$apply();
                }, 1000);
            } else {
                this.isDeployed = false;
                this.deployStatus = 'FAILED';
                this.$timeout(() => {
                    $scope.$apply();
                }, 1000);
            }
        });
    }

    $onInit() {
        // this.busy = true;
        this.state = this.LOGIN_STATE;

        if (!this.$stateParams.stateObject) {
            var url = this.$location.absUrl();
            var arr = url.split('?');
            if (url.length > 1 && arr[1]) {
                let paramsArray = arr[1].split("&");
                let params = {};
                paramsArray.forEach(element => {
                    let temp = element.split("=");
                    params[temp[0]] = temp[1];
                    this.token = decodeURIComponent(params.token);
                });
            }
        }

        if (this.$stateParams.stateObject && this.$localStorage[LOGIN_INITIATED]) {
            this.busy = true;
            let code = this.$stateParams.stateObject.code;
            this.registrationService.login(code)
                .then((res) => {
                    this.registrationService.setIdToken(res[0].token.accessToken);
                    this.$timeout(() => {
                        if (res && res.length > 0);
                        this.changeState(this.REGISTRATION_STATE);
                        this.busy = true;
                        this.token = decodeURIComponent(this.$stateParams.stateObject.state);
                        this.getCountries();
                        this.getSubscription();
                        this.busy = false;
                    }, 1000);
                }, this.handleError);
        }
        this.$element.find('input').first().focus();
        this.handleError = (err) => {
            this.message = err.data && err.data.error ? err.data.error.message : 'An Error Has Occurred';
            this.busy = false;
        };
    }

    getCountries() {
        this.registrationService.getCountries().then(res => {
            res.forEach((item, index) => {
                item.id = index;
                this.countries.push(item);
            });
            this.busy = false;
        });
        this.offsetCountries = this.countries;

    }

    searchCountry() {
        this.offsetCountries = this.countries.filter(country => country.label.toLowerCase().indexOf(this.countrySearch.searchBy.toLowerCase()) !== -1);
    }

    signUp() {
        this.chooseAzureMail();
    }

    chooseAzureMail() {
        this.$localStorage[LOGIN_INITIATED] = true;

        const loginUrl = `${this.msalConfig.identityMetadata}/authorize?client_id=${this.msalConfig.clientId
            }&response_type=code&response_mode=query&scope=${this.msalConfig.scope[0]}&prompt=select_account&state=${this.token}&redirect_uri=${this.msalConfig.redirectUrl
            }`;

        window.location.href = loginUrl;
    }

    setCarousel(carousel) {
        this.carousel = carousel;
    }

    getSubscription(billingPlan) {
        this.loadingSubscriptions = true;
        this.subscriptions = [];
        this.registrationService.getSubscription().then(res => {
            res.forEach((item, index) => {
                let sub = {};
                sub.label = item.name;
                sub.value = item.uuid;
                sub.disabled = item.subscribed;
                sub.isSubscribed = item.subscribed;
                this.subscriptions.push(sub);
            });
            this.loadingSubscriptions = false;
        });
    }

    submitBillingPlan() {
        // this.busy = true;
        let data = {
            token: this.token
        };

        this.changeState(this.PROGRESS_STATE);

        // this.$timeout(() => {
        //     this.resolveStatus = 'DONE';
        //     this.activateStatus = 'RUNNING';
        //     this.$timeout(() => {
        //         this.activateStatus = 'DONE'
        //         this.deployStatus = 'RUNNING'
        //         this.sseService.addEventListener('sse', this.config.registryUrl, true, this.registration.subscription);
        //         this.$timeout(() => {
        //             this.registrationService.triggerSSE(this.registration.subscription.value).then(res => {
        //                 console.log(res)
        //             });
        //         }, 5000);
        //     }, 2000);
        // }, 2000);

        this.registrationService.resolveDeploy(data).then(res => {
            if (res.statusCode === 200) {
                this.resolveStatus = 'DONE';
                this.activateStatus = 'RUNNING';
                this.resolveData = res.entities[0];
                data = this.prepareActivateData(this.resolveData);
                this.registrationService.activateDeploy(this.resolveData.id, data).then(res => {
                    if (res.statusCode === 200) {
                        this.activateStatus = 'DONE';
                        this.deployStatus = 'RUNNING';
                        data = this.prepareStartDeployData();
                        this.sseService.addEventListener('sse', this.config.registryUrl, true, this.registration.subscription);
                        this.registrationService.startDeploy(data)
                            .then(res => {
                                // if (res.statusCode === 202) {
                                // this.deployStatus = 'DONE'
                                // this.isDeployed = true;
                                // } else 
                                if (res.statusCode === 500) {
                                    this.deployStatus = 'FAILED';
                                }
                            });
                    } else if (res.statusCode === 500) {
                        this.activateStatus = 'FAILED';
                        this.deployStatus = 'FAILED';
                    }
                });
            } else if (res.statusCode === 500) {
                this.resolveStatus = 'FAILED';
                this.activateStatus = 'FAILED';
                this.deployStatus = 'FAILED';
            }
        });
    }

    prepareActivateData(data) {
        return {
            planId: data.planId,
            quantity: data.quantity,
            customer: {
                firstName: this.registration.firstName,
                lastName: this.registration.lastName,
                phoneNumber: this.registration.phoneNumber,
                company: this.registration.company,
                country: this.registration.country.label,
                email: [this.registration.email]
            },
            subscriptionUuid: this.registration.subscription.value,
            subscriptionName: this.registration.subscription.label
        };
    }

    prepareStartDeployData() {
        return {
            resourceId: this.resolveData.id,
            subscriptionUuid: this.registration.subscription.value
        };
    }

    processMessage(message) {
        return message.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    close() {
        window.close();
    }

    goBack(step) {
        this.carousel.goTo(step);
    }

    changeStateAction(state) {
        this.state = state;
    }

    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            "xKvp[N/mu-u69uWwxLXU1a[e6@FAAA8Y";
            this.changeStateAction(state);
        }
    }

    openApplication() {
        window.location = this.config.proxyUrl;
    }
}

RegistrationController.$inject = ['$element', '$rootScope', '$scope', '$stateParams', '$filter', '$timeout', '$location', '$localStorage', 'registrationService', 'validationsService', 'config', 'contentSwitcherService', 'sseService'];

const registrationController = {
    controller: RegistrationController,
    template: require('./registration.template.html')
};

module.exports = registrationController;


// WEBPACK FOOTER //
// ./src/azurebackup/views/registration/registration.component.js